import callAPI from 'config/api';

const API_VERSION = 'api/v1';
const ROOT_API = process.env.NEXT_PUBLIC_API;

export async function getActivate() {
  const url = `${ROOT_API}/hub/${API_VERSION}/activation`;

  return callAPI({
    url,
    method: 'GET',
    token: true,
    locationId: true,
  });
}
export async function changeActivate(id, data) {
  const url = `${ROOT_API}/hub/${API_VERSION}/activation/${id}`;

  return callAPI({
    url,
    method: 'PUT',
    token: true,
    locationId: true,
    data,
  });
}
export async function activateToday(id) {
  const url = `${ROOT_API}/hub/${API_VERSION}/activation/${id}`;

  return callAPI({
    url,
    method: 'POST',
    token: true,
    locationId: true,
  });
}
export async function getIndustry() {
  const url = `${ROOT_API}/hub/${API_VERSION}/registration/data/industry`;

  return callAPI({
    url,
    method: 'GET',
    token: true,
  });
}
export async function getBusinesSize() {
  const url = `${ROOT_API}/hub/${API_VERSION}/registration/data/business-size`;

  return callAPI({
    url,
    method: 'GET',
    token: true,
  });
}
export async function getProvince() {
  const url = `${ROOT_API}/hub/${API_VERSION}/registration/data/provinces`;

  return callAPI({
    url,
    method: 'GET',
    token: true,
    locationId: true,
  });
}
export async function getCity(id) {
  const url = `${ROOT_API}/hub/${API_VERSION}/registration/data/cities/${id}`;

  return callAPI({
    url,
    method: 'GET',
    token: true,
    locationId: true,
  });
}
export async function getPlan(id) {
  const url = `${ROOT_API}/hub/${API_VERSION}/plans/${id}`;

  return callAPI({
    url,
    method: 'GET',
    token: true,
    locationId: true,
  });
}
export async function getDetailPlan(id) {
  const url = `${ROOT_API}/hub/${API_VERSION}/plans/detail/${id}`;

  return callAPI({
    url,
    method: 'GET',
    token: true,
    locationId: true,
  });
}
export async function getDataByEmail(email) {
  const url = `${ROOT_API}/hub/${API_VERSION}/webinar-registration/registrant/${email}`;

  return callAPI({
    url,
    method: 'GET',
    token: true,
    locationId: true,
  });
}
export async function createRegistration(data) {
  const url = `${ROOT_API}/hub/api/v1/registration/`;

  return callAPI({
    url,
    method: 'POST',
    token: true,
    locationId: true,
    data,
  });
}
